// Generated file : do not modify
import { MetaValue } from '@/extend/classes/MetaAttrib';
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ConnectionParamModes } from '@/generated/classes/Session';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import Contact from '@/extend/classes/Contact';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Utilisateurs
export default class User extends Contact {
  // Identifiant
  public identifiant: string;
  // Masque du profil utilisateur
  public profil: number;
  // Masque du profil utilisateur
  public currentProfil: number;
  // Première connexion
  public firstConnexion: boolean;
  // Compte désactivé
  public disabled: boolean;
  // Numéro de client CI-98
  public client98: number;
  // Dialog migration CI-98
  public dialog98: string;
  // Mode de connexion
  public connectionMode: ConnectionParamModes;
  // Se souvenir de moi
  public rememberMe: boolean;
  // Code de vérification
  public code: string;
  // Mot de passe défini
  public hasPassword: boolean;
  // Module dont le wizard a été affiché
  public modules: string[];
  // Date dont le CGU a été accepté
  public cguAcceptedAt: Date | null;
  // Méta-attributs
  public metaValues: MetaValue[];
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Identifiant unique
  public id: number;
  // Civilité
  public civiliteId: number;
  // Prénom
  public prenom: string;
  // Nom
  public nom: string;
  // Qualité
  public qualiteId: number;
  // Adresse mail
  public mailId: number;
  // Adresse mail
  public mail: string;
  // Numéro de téléphone
  public numeroId: number;
  // Téléphone
  public numero: string;
  // Adresse postale
  public adresseId: number;
  // Vérification demandée au serveur
  public verify: boolean;
  // Validation effectué par le serveur
  public valid: boolean;
  // Contact associé à un utilisateur
  public isUser: boolean;
  // Recipient id edusign
  public eduSignRecipientId: string;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    super();
    this.identifiant = '';
    this.profil = 0;
    this.currentProfil = 0;
    this.firstConnexion = false;
    this.disabled = false;
    this.client98 = 0;
    this.dialog98 = '';
    this.connectionMode = ConnectionParamModes.NONE;
    this.rememberMe = false;
    this.code = '';
    this.hasPassword = false;
    this.modules = [];
    this.cguAcceptedAt = null;
    this.metaValues = [];
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
    this.id = 0;
    this.civiliteId = 0;
    this.prenom = '';
    this.nom = '';
    this.qualiteId = 0;
    this.mailId = 0;
    this.mail = '';
    this.numeroId = 0;
    this.numero = '';
    this.adresseId = 0;
    this.verify = false;
    this.valid = false;
    this.isUser = false;
    this.eduSignRecipientId = '';
    this.owner = new Owner();
  }

  public static fromJson (obj: User): User {
    const newUser: User = new User();
    newUser.identifiant = obj.identifiant;
    newUser.profil = obj.profil;
    newUser.currentProfil = obj.currentProfil;
    newUser.firstConnexion = obj.firstConnexion;
    newUser.disabled = obj.disabled;
    newUser.client98 = obj.client98;
    newUser.dialog98 = obj.dialog98;
    newUser.connectionMode = obj.connectionMode;
    newUser.rememberMe = obj.rememberMe;
    newUser.code = obj.code;
    newUser.hasPassword = obj.hasPassword;
    newUser.modules = JSON.parse(JSON.stringify(obj.modules));
    newUser.cguAcceptedAt = obj.cguAcceptedAt ? new Date(obj.cguAcceptedAt) : null;
    newUser.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newUser.createId = obj.createId;
    newUser.failed = obj.failed;
    newUser.canUpdate = obj.canUpdate;
    newUser.canDelete = obj.canDelete;
    newUser.display = obj.display;
    newUser.clientId = obj.clientId;
    newUser.notifDefType = obj.notifDefType;
    newUser.id = obj.id;
    newUser.civiliteId = obj.civiliteId;
    newUser.prenom = obj.prenom;
    newUser.nom = obj.nom;
    newUser.qualiteId = obj.qualiteId;
    newUser.mailId = obj.mailId;
    newUser.mail = obj.mail;
    newUser.numeroId = obj.numeroId;
    newUser.numero = obj.numero;
    newUser.adresseId = obj.adresseId;
    newUser.verify = obj.verify;
    newUser.valid = obj.valid;
    newUser.isUser = obj.isUser;
    newUser.eduSignRecipientId = obj.eduSignRecipientId;
    newUser.owner = JSON.parse(JSON.stringify(obj.owner));
    return newUser;
  }

  public toJsonUser (): string {
    const json = {
      identifiant: this.identifiant,
      profil: this.profil,
      currentProfil: this.currentProfil,
      firstConnexion: this.firstConnexion,
      disabled: this.disabled,
      client98: this.client98,
      dialog98: this.dialog98,
      connectionMode: this.connectionMode,
      rememberMe: this.rememberMe,
      code: this.code,
      hasPassword: this.hasPassword,
      modules: this.modules,
      cguAcceptedAt: this.cguAcceptedAt ? new Date (this.cguAcceptedAt).toString() : this.cguAcceptedAt,
      metaValues: this.metaValues,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
      civiliteId: this.civiliteId,
      prenom: this.prenom,
      nom: this.nom,
      qualiteId: this.qualiteId,
      mailId: this.mailId,
      mail: this.mail,
      numeroId: this.numeroId,
      numero: this.numero,
      adresseId: this.adresseId,
      verify: this.verify,
      valid: this.valid,
      isUser: this.isUser,
      eduSignRecipientId: this.eduSignRecipientId,
    }
    return JSON.stringify(json);
  }

  public fromUser (obj: User): void {
    this.identifiant = obj.identifiant;
    this.profil = obj.profil;
    this.currentProfil = obj.currentProfil;
    this.firstConnexion = obj.firstConnexion;
    this.disabled = obj.disabled;
    this.client98 = obj.client98;
    this.dialog98 = obj.dialog98;
    this.connectionMode = obj.connectionMode;
    this.rememberMe = obj.rememberMe;
    this.code = obj.code;
    this.hasPassword = obj.hasPassword;
    this.modules = obj.modules;
    this.cguAcceptedAt = obj.cguAcceptedAt;
    this.metaValues = obj.metaValues;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
    this.id = obj.id;
    this.civiliteId = obj.civiliteId;
    this.prenom = obj.prenom;
    this.nom = obj.nom;
    this.qualiteId = obj.qualiteId;
    this.mailId = obj.mailId;
    this.mail = obj.mail;
    this.numeroId = obj.numeroId;
    this.numero = obj.numero;
    this.adresseId = obj.adresseId;
    this.verify = obj.verify;
    this.valid = obj.valid;
    this.isUser = obj.isUser;
    this.eduSignRecipientId = obj.eduSignRecipientId;
    this.owner = obj.owner;
  }

  public compareUser (value: User): boolean {
    return (this.toJsonUser() == value.toJsonUser());
  }

  public cloneUser (): User {
    return User.fromJson(this);
  }

  public createForStoreUser (): Promise<User> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromUser(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreUser (): Promise<User> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/users/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromUser(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreUser (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/users/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static setProfil (profil: number): Promise<User> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/users/setProfil/' + profil, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(User.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static acceptCgu (isAccepted: boolean): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/users/acceptCgu/' + isAccepted, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static showCgu (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/users/showCgu', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static cguAccepted (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/users/cguAccepted', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static sendCodeMail (user: User): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/sendCodeMail', user, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static validateMail (user: User): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/validateMail', user, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static sendCodeNumero (user: User): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/sendCodeNumero', user, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static validateNumero (user: User): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/users/validateNumero', user, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Users/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = User.fromJson(listData.reccords[0] as User);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<User> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Users/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = User.fromJson(listData.reccords[0] as User);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(users: User[]) {
    users.forEach((item) => {
      item.cguAcceptedAt = item.cguAcceptedAt ? new Date(item.cguAcceptedAt) : item.cguAcceptedAt;
    })
  }
}
